// extracted by mini-css-extract-plugin
export default {"link":"MainLink_link__ArjwK","decorateBlock":"MainLink_decorateBlock__WXf0k","title":"MainLink_title__f1iKc","text":"MainLink_text__dVM1k"};